import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../context/AuthContext";
import { userSelector } from "../../store/selectors";
import ProfileSidebar from "../../components/ProfileSidebar/ProfileSidebar";
import emailjs from "@emailjs/browser";
import "./SupportScreen.css";
import ProfileMainIcon from "../../assets/profile-main.svg";
import TextField from "@mui/material/TextField";

import ProfileBillingIcon from "../../assets/profile-billing.svg";
import ProfileNotificationsIcon from "../../assets/profile-notifications.svg";
import ProfileSecurityIcon from "../../assets/profile-security.svg";
import ProfileTeamIcon from "../../assets/users.svg";
import ProfileActiveSessionsIcon from "../../assets/profile-active-sessions.svg";
import Avatar from "../../components/Avatar/Avatar";
import AppLogo from "../../assets/AppLogoBlue.svg";
import toast from "react-hot-toast";
import { submitFeedback, updatePassword } from "../../store/usersSlice";

import { IconButton, InputAdornment } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import NotificationsPopup from "../../components/NotificationsPopup/NotificationsPopup";
import ProfilePopup from "../../components/ProfilePopup/ProfilePopup";
import PrimaryButton from "../../components/PrimaryButton/PrimaryButton";
import InfoModal from "../../components/InfoModal/InfoModal";
import { ReactComponent as MenuIcon } from "../../assets/mobile/menu.svg";
import useIsMobile from "../../hooks/useIsMobile";

const SupportScreen = () => {
  const user = useSelector(userSelector);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { logout } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [nameValue, setNameValue] = useState(user.firstName);
  const [emailValue, setEmailValue] = useState(user.email);
  const [messageValue, setMessageValue] = useState("");
  const [isSuccessModalVisible, setIsSuccessModalVisible] = useState(false);
  const [submitAvailable, setSubmitAvailable] = useState(false);
  const isMobile = useIsMobile();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const form = useRef();

  const inputFieldCx = {
    input: { color: "#F1F7FF" },
    display: "flex",
    width: isMobile ? "100%" : 403,
    fontSize: 15,
    borderRadius: 8,
    fontWeight: 500,
    backgroundColor: "#1f242e",
    // border: "1px solid #333b4b",
    borderRadius: "8px",
    "& .MuiInputBase-root.Mui-focused": {
      border: "1px solid #3496FF",
      borderRadius: "8px",
      boxSizing: "border-box",
    },
    "& .MuiInputBase-root": {
      border: "1px solid #333b4b",
      borderRadius: "8px",
      boxSizing: "border-box",
    },
    "& .MuiInputLabel-root": {
      color: "#717B8E",
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: "#3496FF",
    },
  };

  useEffect(() => {
    document.title = "7cut • Поддержка";
  }, []);

  useEffect(() => {
    if (!!nameValue && !!emailValue && !!messageValue) {
      setSubmitAvailable(true);
    } else {
      setSubmitAvailable(false);
    }
  }, [nameValue, emailValue, messageValue]);

  const getInputSlotProps = (value) => {
    return {
      input: {
        disableUnderline: true,
        endAdornment: (
          <InputAdornment position="end">
            {/* <IconButton
              sx={{ color: "#717B8E", marginRight: "0px" }}
              onClick={() => callback(!value)}
              edge="end"
            >
              {value ? <Visibility /> : <VisibilityOff />}
            </IconButton> */}
          </InputAdornment>
        ),
      },
    };
  };

  const handleSendMessage = async () => {
    if (!messageValue || isLoading) return;
    setIsLoading(true);
    const settings = {
      name: nameValue,
      email: emailValue,
      message: messageValue,
    };
    dispatch(submitFeedback({ feedbackData: settings })).then((res) => {
      if (!res.error) {
        setIsLoading(false);
        setMessageValue("");
        setIsSuccessModalVisible(true);
      } else {
        setIsLoading(false);
        toast.error("Ошибка отправки! Повторите позже");
      }
    });
    // emailjs
    //   .send("service_w9wc28j", "template_wm35seu", settings, {
    //     publicKey: "RQNmWP7GoOohmwtjr",
    //   })
    //   .then((res) => {
    //     setIsLoading(false);
    //     setMessageValue("");
    //     setIsSuccessModalVisible(true);
    //   });
  };

  if (!user) return null;

  return (
    <div className={isMobile ? "App-mobile" : "App"}>
      {/* HEADER */}
      <div
        className={isMobile ? "mainScreenHeader-mobile" : "mainScreenHeader"}
      >
        <div className={isMobile ? "header-left-mobile" : "header-left"}>
          {isMobile && (
            <div
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              style={{ display: "flex", marginTop: 7 }}
            >
              <MenuIcon color="white" />
            </div>
          )}
          <div
            onClick={() => navigate("/home", { replace: true })}
            className={"mainScreen-logoBlock"}
            style={{ cursor: "pointer" }}
          >
            <img src={AppLogo} style={{ height: "100%" }} alt="logo" />
          </div>
        </div>
        <div className="header-actions">
          <NotificationsPopup />
          <ProfilePopup />
        </div>
      </div>
      {/* LAYOUT: sidebar + main content */}
      <div className="support-container" style={{ alignItems: "flex-start" }}>
        {/* SIDEBAR */}
        {((!isMobile || isMenuOpen) && (
          <ProfileSidebar activeTab="support" />
        )) ||
          null}
        {/* MAIN CONTENT */}
        <main className={isMobile ? "support-main-mobile" : "support-main"}>
          <h1 className="support-title">Поддержка 7cut</h1>
          <span className="support-subtitle">
            Заполните данные и наши менеджеры{"\n"}свяжутся с вами в ближайшее
            время
          </span>
          <form ref={form} onSubmit={() => {}}>
            <TextField
              slotProps={getInputSlotProps(nameValue)}
              sx={inputFieldCx}
              id="filled-basic"
              label="Имя"
              variant="filled"
              margin="normal"
              type={"text"}
              value={nameValue}

              // onChange={(e) => setNameValue(e.target.value)}
            />
            <TextField
              slotProps={getInputSlotProps(emailValue)}
              sx={inputFieldCx}
              autoComplete={false}
              id="filled-basic"
              label="Электронная почта"
              variant="filled"
              margin="normal"
              type={"text"}
              value={emailValue}
              // onChange={(e) => setEmailValue(e.target.value)}
            />
            <TextField
              slotProps={getInputSlotProps(messageValue)}
              sx={inputFieldCx}
              autoComplete={false}
              id="filled-basic"
              label="Ваш вопрос"
              variant="filled"
              margin="normal"
              type={"text"}
              value={messageValue}
              onChange={(e) => setMessageValue(e.target.value)}
            />
          </form>
          <PrimaryButton
            onClick={() => {
              if (!isLoading) {
                setIsLoading(true);
                handleSendMessage();
              }
            }}
            isLoading={isLoading}
            disabled={!submitAvailable}
            text={"Отправить"}
            style={{
              padding: "16px 32px",
              alignSelf: "flex-start",
              fontSize: 16,
              marginTop: 15,
            }}
          />
          <InfoModal
            actionText={"Закрыть"}
            action={() => {
              setIsSuccessModalVisible(false);
            }}
            modalStyles={{ padding: 32 }}
            title="Спасибо за обращение"
            text="Ответ придет на почту, которую вы указали в обращении"
            isOpen={isSuccessModalVisible}
            onClose={() => setIsSuccessModalVisible(false)}
          />
        </main>
      </div>
    </div>
  );
};

export default SupportScreen;
